import './SliderHandle.1a79dfff93f29b7baf46a8f48ee911db.css';
export default {"handle":"_handle_1sdtj_1"};